<template>
  <div>
    <div v-if="card.header" class="card-header">
      <span>{{ card.header }}</span>
    </div>
    <div v-else class="card-header empty"><span> </span></div>
    <div v-if="card.image_url" class="card-img-wrapper">
      <div class='card-img' :style="{ 'background-image': 'url(' + card.image_url + ')' }" />
    </div>
    <div v-if="card.title" class="card-title">
      <h3>
        <a v-if="card.title_url" :href="card.title_url">{{ card.title }}</a>
        <a v-else>{{ card.title }}</a>
      </h3>
    </div>
    <div class="card-content" v-if="card.content" v-html="card.content"></div>
    <div class="card-content" v-if="card.text" v-html="card.text"></div>
    <div v-if="card.first_link_name || card.second_link_name" class="card-links">
      <div class="link-content">
        <a v-if="card.first_link_name" :href="card.first_link_url" class="nav-item">{{ card.first_link_name }}</a>
        <a v-if="card.second_link_name" :href="card.second_link_url" class="nav-item">{{ card.second_link_name }}</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss">


.card-big .card-header {
  color: rgb($secondary-color);
}
.card-header {
  margin: -9px auto 0 auto;
  padding: 0 !important;
  z-index: 5;
  display: flex;
  justify-content: center;
  span {
    font-size: 1.5rem;
    background-color: rgb($quaternary-color);
    padding: 0 30px 5px 30px;
    // white-space: nowrap;
    flex-shrink: 0;
  }
}
.empty {
  z-index: -50;
}


.card-img-wrapper {
  margin: -36px 0 20px 0;
  .card-img {
    vertical-align: unset;
    width: 100%;
    height: 500px;
    background: no-repeat center center;
    background-size: cover;
  }
}

.card-title {
  margin: 30px 15px 15px 15px;
  h3 {
    text-transform: uppercase;
    margin: auto;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }
}

.card-date {
  margin: 0 15px 5px 15px;
  p {
    font-size: 12pt;
    font-weight: 300;
  }
}


.card-details {
  margin: 5px 0 5px 15px;
  font-weight: 300;
  font-size: 14px;
  span {
    font-weight: 600;
  }
}

.card-links {
  margin: 0;
  text-transform: uppercase;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 52px;
  display: table;

  div {
    text-align: left;
  }
  .link-content {
    font-size: 22pt;
    text-align: left;
    display: table-row;
    vertical-align: middle;

    a.nav-item {
      display: table-cell;
    }

    :before {
      margin-right: 5px;
      margin-left: 25.5px;
    }
    :hover::before {
      margin-right: 5px;
      margin-left: 5px;
    }
  }
}

.card-content {
  margin: 30px 15px 15px 15px;
  font-size: 2rem;
  font-weight: 200;
}

@media (min-width: 1200px) and (max-width: 1399px), (min-width: 768px) and (max-width: 1000px), (max-width: 450px) {
  .card-title {
    h2 {
      font-size: 2.3rem;
    }
  }
}

@media (max-width: 767.98px) {
  .card-links {
    position: relative!important;
  }
}

@media (max-width: 350px) {
  .card-header {
    margin: -6px auto 0 auto;
    span {
      font-size: 1.3rem;
    }
  }
  .card-title {
    h2 {
      font-size: 2rem;
    }
  }
  .card-links {
    .link-content {
      font-size: 18pt;
      :before {
        margin-right: 3px;
        margin-left: 20.5px;
      }
      :hover::before {
        margin-right: 4.5px;
        margin-left: 2px;
      }
    }
  }
}

</style>

<script>
export default {
  name: "fcwpSidebarCard",
  props: ["card"]
};
</script>